import React, { useCallback } from "react";
import { Modal } from "@mui/material";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { downloadListing } from "../../Services/ApiCalling/Listing";
import { SuccessMessage } from "../Toast/ErrorMessage";
import { Close } from "@mui/icons-material";
import { ReactComponent as Download } from "../../assets/images/downloadFile.svg";
import { fetchDownloadDocument } from "../../Redux/Slices/bankingSlice";
import { useDispatch } from "react-redux";
import { saveAs } from "file-saver";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PreviewModal = ({ open, onClose, fileUrl, documentId, fileName }) => {
  const dispatch = useDispatch();

  const handleDownload = useCallback(async () => {
    try {
      if (fileUrl) {
        const response = await fetch(fileUrl);
        const blob = await response.blob();

        if (blob.size === 0) {
          console.error("Empty document received");
          return;
        }

        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers.get("Content-Disposition");
        let downloadFileName = fileName;

        if (!downloadFileName && contentDisposition) {
          const filenameMatch = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (filenameMatch && filenameMatch[1]) {
            downloadFileName = filenameMatch[1].replace(/['"]/g, "");
          }
        }

        // Fallback: Extract from URL path
        if (!downloadFileName && fileUrl) {
          try {
            const urlPath = new URL(fileUrl).pathname;
            const urlFileName = urlPath.substring(urlPath.lastIndexOf("/") + 1);
            if (urlFileName && urlFileName.includes(".")) {
              downloadFileName = decodeURIComponent(urlFileName);
            }
          } catch (e) {
            console.log("Could not extract filename from URL");
          }
        }

        // Final fallback
        if (!downloadFileName) {
          downloadFileName = documentId
            ? `document_${documentId}.pdf`
            : "terms_and_conditions.pdf";
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = downloadFileName;
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        SuccessMessage("Downloaded successfully!");
      } else {
        const result = dispatch(fetchDownloadDocument(documentId));

        if (fetchDownloadDocument.rejected.match(result)) {
          console.error("Download failed:", result.payload);
          return;
        }

        const blob = result.payload;

        if (!blob || blob.size === 0) {
          console.error("Empty document received from API");
          return;
        }

        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const url = URL.createObjectURL(pdfBlob);

        const link = document.createElement("a");
        link.href = url;
        link.download =
          fileName ||
          (documentId
            ? `document_${documentId}.pdf`
            : "terms_and_conditions.pdf");
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 100);

        SuccessMessage("Downloaded successfully!");
      }
    } catch (error) {
      console.error("Download error:", error);
    }
  }, [documentId, dispatch, fileUrl, fileName]);

  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          width: "80vw",
          height: "80vh",
          background: "#fff",
          margin: "5vh auto",
          padding: 16,
          display: "flex",
          flexDirection: "column",
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          overflow: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div onClick={handleDownload} style={{ cursor: "pointer" }}>
            <Download />
          </div>
          <div onClick={onClose} style={{ cursor: "pointer" }}>
            <Close />
          </div>
        </div>
        <div style={{ flex: 1, overflow: "auto" }}>
          <Document
            file={fileUrl}
            onLoadError={console.error}
            loading={<div>Loading PDF...</div>}
            error={<div>Failed to load PDF.</div>}
          >
            <Page pageNumber={1} width={window.innerWidth * 0.7} />
          </Document>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewModal;
